// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aSxSDrSZa24XnblMXq0lyA\\=\\={border-radius:0}", "",{"version":3,"sources":["webpack://./resources/react/Components/ui/ColorInputV2.module.css"],"names":[],"mappings":"AAAA,4BACI,eACJ","sourcesContent":[".section{\n    border-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "aSxSDrSZa24XnblMXq0lyA=="
};
export default ___CSS_LOADER_EXPORT___;
